import {
  Directive,
  HostBinding,
  Input,
  Output,
  EventEmitter,
  HostListener,
  ElementRef,
} from "@angular/core";
import { Observable } from "rxjs/Observable";
import { EmptyObservable } from "rxjs/observable/EmptyObservable";

declare var braintree: any;

export class PaymentMethodResult {
  requestPaymentMethodErr: any;
  payload: any;
}

@Directive({
  selector: "[appBtpay]",
})
export class BtpayDirective {
  @HostBinding("attr.id") id: string;
  @HostListener("click", ["$event.target"]) click(target) {
    if (target.classList.contains("braintree-option__label")) {
      this.showButton.emit(true);
    }
  }
  @Input() currency: string;
  @Input() amount: string;
  @Output() containerLoaded: EventEmitter<void> = new EventEmitter<void>();
  @Output() methodChanged: EventEmitter<void> = new EventEmitter<void>();
  @Output() showButton: EventEmitter<boolean> = new EventEmitter<false>();

  private _btpayInstance: any;
  private _3dsecureInstance: any;

  configure(clientToken: string) {
    this.id = "btpay-container";
    console.log(
      "[BtpayDirective.configure] initialized with amount " +
        this.amount +
        ", currency " +
        this.currency
    );

    this.showButton.emit(true);
    braintree.dropin.create(
      {
        authorization: clientToken,
        container: "#" + this.id,
        locale: "it_IT",
        threeDSecure: true,
        /* 
        threeDSecure: {
          amount: this.amount,
        },
        */
        paypal: {
          flow: "checkout",
          amount: this.amount,
          currency: this.currency,
        },
      },
      (err, instance) => {
        console.log("drop in create ", err, "dropin instance", instance);
        if (err) {
          console.error("braintree.dropin.create error:", err);
        }

        this.containerLoaded.emit();
        this._btpayInstance = instance;
        /*
        braintree.threeDSecure.create(
          {
            version: 2, // Will use 3DS2 whenever possible
            client: this._btpayInstance,
          },
          (threeDSecureErr, threeDSecureInstance) => {
            if (threeDSecureErr) {
              // Handle error in 3D Secure component creation
              console.log("threeDSecureErr", threeDSecureErr);
              return;
            }

            console.log("threeDSecureInstance", threeDSecureInstance);

            this._3dsecureInstance = threeDSecureInstance;
          }
        );
        */

        if (instance) {
          instance.on("noPaymentMethodRequestable", () =>
            this.methodChanged.emit()
          );
        }
      }
    );
  }

  requestPaymentMethod(): Observable<PaymentMethodResult> {
    console.log("[BtpayDirective.requestPaymentMethod] called");
    const payResult = new PaymentMethodResult();
    if (this._btpayInstance) {
      return new Observable((observer) => {
        const threeDSecureParameters = {
          amount: this.amount,
          collectDeviceData: true,
          /*
          email: "giacomonapoli@gmail.com",
          billingAddress: {
            givenName: "Giacomo", // ASCII-printable characters required, else will throw a validation error
            surname: "Napoli", // ASCII-printable characters required, else will throw a validation error
            phoneNumber: "+393200467829",
            streetAddress: "Viale Ezra Pound 85",
            extendedAddress: "",
            locality: "Roma",
            region: "RM", // ISO-3166-2 code
            postalCode: "00137",
            countryCodeAlpha2: "IT",
          },
          additionalInformation: {
            workPhoneNumber: "8101234567",
            shippingGivenName: "Jill",
            shippingSurname: "Doe",
            shippingPhone: "8101234567",
            shippingAddress: {
              streetAddress: "555 Smith St.",
              extendedAddress: "#5",
              locality: "Oakland",
              region: "CA", // ISO-3166-2 code
              postalCode: "12345",
              countryCodeAlpha2: "US",
            },
          },
          */
        };
        console.log("threeDSecureParameters", threeDSecureParameters);

        this._btpayInstance.requestPaymentMethod(
          { threeDSecure: threeDSecureParameters },
          (requestPaymentMethodErr, payload) => {
            console.log("requestPaymentMethodErr", requestPaymentMethodErr);
            console.log("payload", payload);
            payResult.requestPaymentMethodErr = requestPaymentMethodErr;
            payResult.payload = payload;
            observer.next(payResult);
          }
        );
        /*
        this._3dsecureInstance.verifyCard(
          threeDSecureParameters,
          (err, response) => {
            if (err) {
              // Handle error
              console.log("err", err);
              return;
            }
            // Send response.nonce to your server for use in your integration
            // The 3D Secure Authentication ID can be found
            //  at response.threeDSecureInfo.threeDSecureAuthenticationId
            console.log("response", response);
            console.log("payload", response.payload);
            payResult.requestPaymentMethodErr =
              response.requestPaymentMethodErr;
            payResult.payload = response.payload;
            observer.next(payResult);
          }
        );
        */
      });
    } else {
      console.error(
        "[BtpayDirective.requestPaymentMethod payAction called without instance of _btpayInstance"
      );
      return new EmptyObservable();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/btpay/btpay.directive.ts